export default __webpack_public_path__ + "static/media/imageLogin.4b849299.jpg";